module.exports = __webpack_public_path__ + "static/img/4312_phase_function_Paper_PointsHejduk_Prediction.870d6f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4312_phase_function_Paper_PointsHejduk_Prediction.png
// module id = I4kz
// module chunks = 0